/**
 * Design Tokens — TypeScript interface
 *
 * Use this for React components that need JS access to token values
 * (e.g., inline styles, dynamic color logic, chart configs).
 *
 * For Tailwind classes, just use the class names directly:
 *   text-fg, bg-surface-hover, border-line, etc.
 *
 * Source of truth: design-tokens.cjs (shared with tailwind.config.js)
 */

import { colors as _colors, fontSize as _fontSize } from './design-tokens.js'

export const colors: Record<string, string> = _colors
export const fontSize: Record<string, [string, { lineHeight: string }]> =
  _fontSize
